// extracted by mini-css-extract-plugin
export default {"Prose":"Prose-module--Prose--3-dKI","Prose--lineLength":"Prose-module--Prose--lineLength--GdfK4"};